import { render, staticRenderFns } from "./Question.vue?vue&type=template&id=eb83fe34"
import script from "./Question.vue?vue&type=script&lang=js"
export * from "./Question.vue?vue&type=script&lang=js"
import style0 from "./Question.vue?vue&type=style&index=0&id=eb83fe34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports